import { getTaggingChannelId } from '../../../utils/lqServiceUtil';
import { apiUrl } from '../../../constants/api-urls';
import callingApi from '../../../services/apiService';
import { MethodType, LQ_VIEWS } from '../../../constants/common';
import { AddressQualification as ActionTypes } from '../../../constants/actionTypes';
import { logMetrics } from '../../../services/logService';
import { openViewVzTag } from '../../../utils/unifiedVzTag';
import { updateCurrentView } from '../../loop-qual-app/actions';

export const emailValidate = (emailAddress, loopQualApp, dispatch) => {
  try {
    let userAction = '';
    if (loopQualApp.currentLQView === LQ_VIEWS.ADDRESS_QUALIFICATION) {
      userAction = 'checkavail-NSA';
    } else {
      userAction = 'serviceunavail-NSA';
    }
    const url = apiUrl().validateEmail;

    const request = {
      meta: {
        client: getTaggingChannelId(),
        user: '',
        clientCorrrelationId: '',
        timestamp: '',
      },
      data: {
        emailId: emailAddress,
        userAction,
        customerType: 'Wireless',
        version: 'v2',
      },
    };
    let flowName;
    const location =
      window.location.search &&
      (window.location.search.indexOf('testQualification') > -1 ||
        window.location.search.indexOf('nsa=y') > -1 ||
        window.location.search.indexOf('NSA=Y') > -1)
        ? 'Y'
        : null;
    if (location && location === 'Y') {
      flowName = 'test|EMAILVALIDATE_5G';
    }
    const requiredflowType = { flowType: flowName, emailCancel: 'Y' };
    return new Promise((resolve, reject) => {
      callingApi(url, MethodType.POST, request, 'application/json', requiredflowType)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  } catch (ex) {
    logMetrics('lbo-emailValidationerror', ex.message, 'Error');
    openViewVzTag('lbo-emailValidationerror');
    dispatch(updateCurrentView(LQ_VIEWS.LBO_VIEW));
  }
};

export const emailVerify = (emailAddress, isLoggedIn, dispatch) => {
  try {
    const url = apiUrl().verifyEmail;

    const request = {
      data: {
        action: 'manual',
        email: emailAddress,
        prospectCustomer: !isLoggedIn,
      },
    };
    let flowName;
    const location =
      window.location.search &&
      (window.location.search.indexOf('testQualification') > -1 ||
        window.location.search.indexOf('nsa=y') > -1 ||
        window.location.search.indexOf('NSA=Y') > -1)
        ? 'Y'
        : null;
    if (location && location === 'Y') {
      flowName = 'test|';
    }
    const requiredflowType = { flowType: flowName };
    return new Promise((resolve, reject) => {
      callingApi(url, MethodType.POST, request, 'application/json', requiredflowType)
        .then((response) => {
          if (response) {
            dispatch({ type: ActionTypes.VERIFY_EMAIL, value: true });
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  } catch (ex) {
    logMetrics('lbo-emailVerificationerror', ex.message, 'Error');
    openViewVzTag('lbo-emailVerificationerror');
    dispatch(updateCurrentView(LQ_VIEWS.LBO_VIEW));
  }
};
